<template>
  <svg id="api" aria-hidden="true" viewBox="0 0 1200 1200" ...attributes>
    <path
      fill="#63CC98"
      d="M520,300a20,20,0,0,1-14.142-34.142l60-60a20,20,0,0,1,28.284,28.284l-60,60A19.937,19.937,0,0,1,520,300Z"
    ></path>
    <path
      fill="#63CC98"
      d="M220,800a20,20,0,0,1-14.142-34.142l60-60a20,20,0,0,1,28.284,28.284l-60,60A19.937,19.937,0,0,1,220,800Z"
    ></path>
    <path
      fill="#63CC98"
      d="M820,800a20,20,0,0,1-14.142-34.142l60-60a20,20,0,0,1,28.284,28.284l-60,60A19.937,19.937,0,0,1,820,800Z"
    ></path>
    <path fill="#1B2D3C" d="M980,960H920V820a20,20,0,0,0-40,0V960H820a20,20,0,1,0,0,40H980a20,20,0,0,0,0-40Z"></path>
    <path fill="#1B2D3C" d="M380,960H320V820a20,20,0,0,0-40,0V960H220a20,20,0,0,0,0,40H380a20,20,0,1,0,0-40Z"></path>
    <path fill="#1B2D3C" d="M680,460H620V320a20,20,0,0,0-40,0V460H520a20,20,0,1,0,0,40H680a20,20,0,0,0,0-40Z"></path>
    <path
      fill="#1B2D3C"
      d="M680,880a20,20,0,0,0-20,20,60,60,0,0,1-120,0,20,20,0,0,0-40,0,100,100,0,0,0,200,0A20,20,0,0,0,680,880Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M600,700A100,100,0,0,0,500,800a20,20,0,0,0,40,0,60,60,0,0,1,120,0,20,20,0,0,0,40,0A100,100,0,0,0,600,700Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M980,380a20,20,0,0,0-20,20,60,60,0,0,1-120,0,20,20,0,1,0-40,0,100,100,0,1,0,200,0A20,20,0,0,0,980,380Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M900,200A100,100,0,0,0,800,300a20,20,0,0,0,40,0,60,60,0,1,1,120,0,20,20,0,1,0,40,0A100,100,0,0,0,900,200Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M380,380a20,20,0,0,0-20,20,60,60,0,0,1-120,0,20,20,0,0,0-40,0,100,100,0,0,0,200,0A20,20,0,0,0,380,380Z"
    ></path>
    <path
      fill="#1B2D3C"
      d="M300,200A100,100,0,0,0,200,300a20,20,0,0,0,40,0,60,60,0,0,1,120,0,20,20,0,0,0,40,0A100,100,0,0,0,300,200Z"
    ></path>
    <circle fill="#7DB9D8" cx="600" cy="850" r="20"></circle>
    <circle fill="#7DB9D8" cx="900" cy="350" r="20"></circle>
    <circle fill="#7DB9D8" cx="300" cy="350" r="20"></circle>
  </svg>
</template>
